import { render, staticRenderFns } from "./ViewUnauthorisedViewing.vue?vue&type=template&id=412240a6&scoped=true&"
import script from "./ViewUnauthorisedViewing.vue?vue&type=script&lang=js&"
export * from "./ViewUnauthorisedViewing.vue?vue&type=script&lang=js&"
import style0 from "./ViewUnauthorisedViewing.vue?vue&type=style&index=0&id=412240a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412240a6",
  null
  
)

export default component.exports